export default "/_next/static/images/46/pictureDesktopMobile-46058db5f885d325caa3e7b69a59ee3e.png";